import React from 'react';
export function Footer() {
  return <footer className="w-full bg-deep-blue" data-id="element-45" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-6xl border-t border-white/10 px-4 py-8 text-center" data-id="element-46" data-mp="3gezeh7brdx2q">
        <p className="font-display text-lg font-bold text-white" data-id="element-47" data-mp="32nun0sijob3h">
          La Biblia en Cómic
        </p>
        <p className="mt-2 text-sm text-cream/60" data-id="element-48" data-mp="36p6c8wxiaub5">
          Descarga inmediata · Pago seguro · Garantía de 7 días
        </p>
        <p className="mt-4 text-xs text-cream/40" data-id="element-49" data-mp="3ug3efhzi2d97">
          © {new Date().getFullYear()} La Biblia en Cómic. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}